import { useState, useEffect } from 'react';

/**
 * @description
 * Автоматически вычисляем высоту свернутого контента
 */
export const useCollapsedHeight = contentRef => {
  const [collapsedHeight, setCollapsedHeight] = useState();
  useEffect(() => {
    const contentElement = contentRef.current;
    const {
      height
    } = contentElement.getBoundingClientRect();
    setCollapsedHeight(height);
  }, [contentRef]);
  return collapsedHeight;
};